import { cloneDeep } from 'lodash';
import { parseLabelFromString } from 'contexts';
import template from './listing_search.html';

angular.module('bb.listing_search').component('listingSearch', {
  bindings: {},
  controller: ListingSearchController,
  controllerAs: 'vm',
  template,
});

ListingSearchController.$inject = [
  '$location',
  '$routeParams',
  '$rootScope',
  'LS',
  '$timeout',
  'ListingSearchService',
  '$httpParamSerializer',
  '$window',
  '$scope',
];
function ListingSearchController(
  $location,
  $routeParams,
  $rootScope,
  LS,
  $timeout,
  ListingSearchService,
  $httpParamSerializer,
  $window,
  $scope,
) {
  const vm = this;

  // These functions are created asynchronously
  const openContactDrawerListener = $rootScope.$watch(
    'openContactDrawer',
    () => {
      if ($rootScope.openContactDrawer) {
        vm.openContactDrawer = $rootScope.openContactDrawer;
        openContactDrawerListener();
      }
    },
  );

  function getSearchParams() {
    const search = cloneDeep(vm.search);

    if (vm.showSearch || ['user', 'team'].includes($routeParams.type)) {
      delete search.includeAllStatuses;
    } else {
      delete search.status;
      delete search.minPrice;
      delete search.maxPrice;
      delete search.location;
      delete search.locationAddress;
      delete search.targetTeamId;
      delete search.avail;
      delete search.agent;
    }

    search.type = vm.search.searchType;

    if (search.targetTeamId === 'All') {
      delete search.targetTeamId;
    }

    return search;
  }

  let favoritesWatchListener;

  vm.$onInit = () => {
    if ($routeParams.type === 'brokerage') return;

    vm.auth = $rootScope.auth;

    vm.showExpiry =
      $routeParams.type !== 'favorites' &&
      (!['AGENT', 'TEAM_ADMIN'].includes(vm.auth.role) ||
        ($routeParams.type === 'team' && vm.auth.role === 'TEAM_ADMIN'));

    vm.openContactDrawer = $rootScope.openContactDrawer;
    vm.allAvailabilitiesToggle = $routeParams.includeAllStatuses !== false;
    vm.businessAvailabilityToggle = $routeParams.avail === 'All';

    vm.toggleAllAvailabilitiesToggle = () => {
      vm.allAvailabilitiesToggle = !vm.allAvailabilitiesToggle;
      $scope.$digest();
    };

    vm.listingTypes = {
      condo: 'Condominium',
      freehold: 'Freehold',
      commercial: 'Commercial',
    };

    vm.showPreview =
      $rootScope.auth.isAdmin &&
      $rootScope.auth.org.features.indexOf('APPOINTMENT') !== -1 &&
      $routeParams.type !== 'favorites';

    vm.showCombineListingButton =
      $routeParams.type === 'team' &&
      vm.auth.roles[vm.auth.role] >= vm.auth.roles.TEAM_ADMIN;

    vm.toggleAdvancedSearch = () => {
      vm.showSearch = !vm.showSearch;
    };

    if ($routeParams.type === 'admin') {
      vm.listingNames = 'Draft';
    } else if ($routeParams.type === 'unassigned') {
      vm.listingNames = 'Unassigned';
    } else if ($routeParams.type === 'unavailable') {
      vm.listingNames = 'Unavailable';
    } else if ($routeParams.type === 'team') {
      vm.listingNames = 'My Team >';
    } else if ($routeParams.type === 'favorites') {
      vm.listingNames = 'My Favorite';
    } else if ($routeParams.type === 'deleted') {
      vm.listingNames = 'Deleted';
    } else {
      // this block implies case of $routeParams.type == 'user' and more.
      vm.hideBranchFilter = true;
      vm.listingNames = 'My Business >';
      if ($routeParams.avail === 'Available') {
        vm.userListing = 'Current';
      } else if ($routeParams.avail === 'All') {
        vm.userListing = 'All';
      }
    }

    vm.search = {
      searchType: $routeParams.type || 'favorites',
      address: $routeParams.address,
      minPrice: $routeParams.minPrice,
      maxPrice: $routeParams.maxPrice,
      status: $routeParams.status || 'All',
      location: $routeParams.location || 'All',
      locationAddress: $routeParams.locationAddress || 'All',
      targetTeamId: $routeParams.targetTeamId || 'All',
      avail: $routeParams.avail || 'Available',
      sort_asc: $routeParams.sort_asc,
      sort_field: $routeParams.sort_field,
      agent: $routeParams.agent,
    };

    vm.printLimit = 300;

    vm.pageNumber = $routeParams.pageNumber || 0;

    vm.pageNumberWidget = Number(vm.pageNumber) + 1;

    vm.status = $routeParams.status;

    vm.locations = ['All'];
    ListingSearchService.getLocations().then(data => {
      vm.locationAddressMap = data.locationIndex;
    });

    vm.teams = [];
    const fetchTeamData = async teamIds => {
      try {
        vm.teams = await ListingSearchService.getTeamsByIds(teamIds);
      } catch (error) {
        console.error('Error fetching team data:', error);
      }
    };

    if (vm.auth.teams?.length > 1) {
      fetchTeamData(vm.auth.teams);
    }

    vm.availabilities = [];

    $rootScope.$watch('labelOverrideMap', async () => {
      vm.getLabel = str =>
        $rootScope.labelOverrideMap[parseLabelFromString(str)]?.label || str;

      vm.isHidden = str =>
        $rootScope.labelOverrideMap[parseLabelFromString(str)]?.hidden || false;

      const availabilities = (await ListingSearchService.getStatuses())
        .filter(
          av => !$rootScope.labelOverrideMap[parseLabelFromString(av)]?.hidden,
        )
        .map(av => ({
          label: vm.getLabel(av),
          value: av,
        }));

      vm.availabilities = [
        ...['Available', 'Unavailable'].map(av => ({
          label: av,
          value: av,
        })),
        ...availabilities,
      ];
    });

    if ($routeParams.includeAllStatuses === true) {
      vm.search.includeAllStatuses = !!$rootScope.auth.isAdmin;
    }

    if ($routeParams.type === 'team' || $routeParams.type === 'user') {
      vm.search.avail = $routeParams.avail || 'All';
    }

    if (
      $routeParams.type !== 'user' &&
      ($routeParams.minPrice ||
        $routeParams.maxPrice ||
        ($routeParams.status && $routeParams.status !== 'All') ||
        ($routeParams.location && $routeParams.location !== 'All') ||
        ($routeParams.targetTeamId && $routeParams.targetTeamId !== 'All') ||
        $routeParams.avail)
    ) {
      vm.toggleAdvancedSearch();
    }

    vm.favorites = $rootScope.favorites ? [...$rootScope.favorites] : [];

    vm.loadSearchListings();

    if ($routeParams.type === 'favorites') {
      favoritesWatchListener = $rootScope.$watch('favorites', newValue => {
        vm.favorites = newValue ? [...newValue] : [];
        vm.loadSearchListings();
      });
    }

    $rootScope.$watch('labelOverrideMap', () => {
      vm.statuses = [
        { value: 'Assignment' },
        { value: 'Coming Soon' },
        { value: 'Exclusive' },
        { value: 'New Construction' },
        { value: 'MLS' },
      ].filter(status => !status.hidden);
    });
    vm.parseLabelFromString = parseLabelFromString;

    vm.changePath = page => {
      $location
        .path(`listing/list/${vm.search.searchType}/${page}`)
        .search(getSearchParams());
      if (!$scope.$$phase && !$rootScope.$$phase) {
        $scope.$apply();
      }
    };

    vm.showCurrent = () => {
      vm.search.avail = 'Available';
      vm.listingType = 'user';
      vm.changePath(0);
    };

    vm.showAll = () => {
      vm.search.avail = 'All';
      vm.listingType = 'user';
      vm.changePath(0);
    };

    vm.toggleAvail = () => {
      vm.businessAvailabilityToggle = !vm.businessAvailabilityToggle;
      if (vm.businessAvailabilityToggle) {
        vm.showAll();
      } else {
        vm.showCurrent();
      }
    };

    vm.changePage = page => {
      vm.changePath(page - 1);
    };

    vm.sort = field => {
      if (vm.search.sort_field === field) {
        vm.search.sort_asc = `${!(vm.search.sort_asc === 'true')}`;
      } else {
        vm.search.sort_asc = 'true';
      }
      vm.search.sort_field = field;

      const page = vm.pageNumber || 0;

      vm.changePath(page);
    };

    // Send Listings
    vm.listingsToSend = {};
    vm.showSendButton = false;

    vm.selectListing = () => {
      let sendListingsActive = false;
      for (const lid in vm.listingsToSend) {
        if (vm.listingsToSend[lid]) {
          sendListingsActive = true;
          break;
        }
      }
      vm.showSendButton = sendListingsActive;
    };

    vm.viewListing = id => {
      $location.path(`listing/${id}/view`);
    };

    vm.sendListings = () => {
      const lids = [];
      for (const lid in vm.listingsToSend) {
        if (vm.listingsToSend[lid]) {
          lids.push(lid);
        }
      }
      $location.path(`listing/send/${lids.join()}`);
    };

    vm.downloadPdf = () => {
      const param = {
        ...getSearchParams(),
        onboardingPortalId: $rootScope.auth.org.onboardingPortalId,
      };

      $window.open(`/my_brokerage_tab_pdf?${$httpParamSerializer(param)}`);
    };

    vm.showingsPath =
      vm.search.searchType === 'user'
        ? `#/my_business/showings/listing`
        : `#/appointment/list/${vm.search.searchType}`;
  };

  vm.$onDestroy = () => {
    if (favoritesWatchListener) {
      favoritesWatchListener();
    }
  };

  vm.loadSearchListings = () => {
    if ($routeParams.type === 'team' && !$rootScope.hasFeature('TEAMS')) {
      vm.TeamFeatureNotIncluded = true;
    } else {
      vm.TeamFeatureNotIncluded = false;
    }
    ListingSearchService.searchListings(
      Object.assign(getSearchParams(), { pageNumber: vm.pageNumber }),
    ).then(data => {
      const { listings, count } = data;

      if ($('#searchBox')) {
        $timeout(() => {
          $('#searchBox').focus();
        }, 0);
      }

      // prev/next for listings;
      const listingIds = listings.map(listing => listing.id).join(',');
      LS.setData('listings', listingIds);

      vm.listings = listings;
      vm.brokerageName = $rootScope.auth.org.name;

      // pagination
      vm.totalListings = count;
      vm.dataLoaded = true;
    });
  };

  vm.changePreviewListing = listing => {
    vm.previewListing = listing;
  };

  vm.advanceSearch = () => {
    vm.search.includeAllStatuses = vm.allAvailabilitiesToggle;
    vm.changePath(0);
  };

  vm.redirectToCombineListing = () => {
    $location.path('listing/merge/options').search({});
  };

  vm.onBranchChange = () => {
    // If selected branch has only one address (sub-brokerage)
    if (
      vm.search.location === 'All' ||
      !vm.locationAddressMap[vm.search.location].addresses[1]
    ) {
      vm.search.locationAddress = 'All';
    }
  };

  vm.showTeamFilter = $rootScope.auth.teams?.length > 1;
}
